module.exports = __webpack_public_path__ + "img/discount.390ee39e.svg";